import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import * as DATANETAPI from "../DataNet/DataNet";
import { DeleteOutline } from "@material-ui/icons";

const DeviceCocheraForm = ({
  trackerLicensePlate,
  setTrackerLicensePlate,
  trackerLocation,
  setTrackerLocation,
  trackerCocheraId,
  setTrackerCocheraId,
  isCocheraFormValid,
  setIsCocheraFormValid,
  formErrors,
  setFormErrors,
  onUnassignBus,
  trackerBusNumber,
  setTrackerBusNumber,
  currentBusNumber
}) => {
  const { t } = useTranslation();
  const phoneRegex = /^(\+34|34)?[6-9]\d{8}$/;
  const numericRegex = /^\d+$/;
  const [locations, setLocations] = useState([]);
  const [openUnassignDialog, setOpenUnassignDialog] = useState(false);

  const handleBusNumber = (event) => {
    setTrackerBusNumber(event.target.value);
    setFormErrors((prev) => ({
      ...prev,
      trackerBusNumber: null
    }));
  };

  const handleOpenUnassignDialog = () => {
    setOpenUnassignDialog(true);
  };

  const handleCloseUnassignDialog = () => {
    setOpenUnassignDialog(false);
  };

  const handleConfirmUnassign = () => {
    setOpenUnassignDialog(false);

    if (onUnassignBus) {
      onUnassignBus();
    }
  };

  useEffect(() => {
    DATANETAPI.getCocherasLocations()
    .then((res) => {
      setLocations(res?.data || []);
    })
    .catch((err) => {
      console.error(err);
      setLocations([]);
    });
  }, []);
  
  useEffect(() => {
    const anyFilled = trackerBusNumber || trackerLocation;

    if (!anyFilled) {
      setIsCocheraFormValid(false);

      setFormErrors((prev) => ({
        ...prev,
        trackerBusNumber: null,
        trackerLocation: null
      }));

      return;
    }

    let busNumberError = null;
    if (!trackerBusNumber) {
      busNumberError = t("account.error.empty");
    } else if (!numericRegex.test(trackerBusNumber)) {
      busNumberError = t("account.error.numeric");
    }

    let locationError = null;
    if (!trackerLocation) {
      locationError = t("account.error.empty");
    }

    setFormErrors((prev) => ({
      ...prev,
      ...(busNumberError
        ? { trackerBusNumber: busNumberError }
        : {}),
      trackerLocation: locationError
    }));

    setIsCocheraFormValid(!busNumberError && !locationError);
  }, [
    trackerBusNumber,
    trackerLocation
  ]);
  
  return (
    <>
      <Grid item xs={12}>
        <Typography
          color="secondary"
          style={{
            fontWeight: 500,
            fontSize: 22,
            lineHeight: "30px",
            marginTop: 16
          }}
        >
          {t("devices.cochera.config.title")}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label={t("common.program")}
          placeholder={t("common.program")}
          variant="outlined"
          value={t("devices.program.emt.title")}
          InputProps={{
            readOnly: true,
            style: { backgroundColor: "#f5f5f5", color: "#868686" }
          }}
          InputLabelProps={{shrink: true}}
          fullWidth
        />
      </Grid>
      <Grid item xs={false} sm={6} />

      <Grid item xs={12} sm={6}>
        <Grid container alignItems="center" wrap="nowrap">
          <Grid item xs>
            <TextField
              label={t("devices.tracking.config.bus_number")}
              placeholder={t("devices.tracking.config.bus_number")}
              variant="outlined"
              onChange={handleBusNumber}
              value={trackerBusNumber}
              inputProps={{ maxLength: 15 }}
              error={!!formErrors.trackerBusNumber}
              helperText={formErrors.trackerBusNumber}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Grid container alignItems="center" wrap="nowrap">
          <FormControl variant="outlined" fullWidth>
            <InputLabel>
              {t("devices.tracking.config.location")}
            </InputLabel>
            <Select
              value={String(trackerCocheraId || "")}
              onChange={(e) => {
                const selected = locations.find(x => String(x.id) === String(e.target.value));
                setTrackerLocation(selected?.name || "");
                setTrackerCocheraId(selected?.id || "");
              }}
              label={t("devices.tracking.config.location")}
            >
              {locations.map((loc) => (
                <MenuItem key={loc.id} value={String(loc.id)}>
                  {loc.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {currentBusNumber && trackerBusNumber === currentBusNumber && (
            <Grid item>
              <Tooltip title={t("devices.tracking.bus.unassign.tooltip")}>
                <IconButton
                  onClick={handleOpenUnassignDialog}
                  style={{ marginLeft: 8, color: "#e53935" }}
                >
                  <DeleteOutline />
                </IconButton>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Dialog open={openUnassignDialog} onClose={handleCloseUnassignDialog}>
        <DialogTitle>
          {t("devices.tracking.bus.unassign.title")}
        </DialogTitle>

        <DialogContent>
          {t("devices.tracking.bus.unassign.message")}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseUnassignDialog} color="default">
            {t("devices.tracking.bus.unassign.cancel").toUpperCase()}
          </Button>
          <Button onClick={handleConfirmUnassign} color="primary" variant="contained">
            {t("devices.tracking.bus.unassign.confirm").toUpperCase()}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeviceCocheraForm;